import axios from 'axios';

const initialState = {
    surveys: [],
};

const state = Object.assign({}, initialState);

const getters = {
    surveys: state => state.surveys,
};

const actions = {
    async fetchSurveys({commit}) {
        const response = await axios.get('/v2/surveys');

        commit('setSurveys', response.data.data);
    }
};

const mutations = {
    setSurveys: (state, surveys) => (state.surveys = surveys),
};

export default {
    state,
    getters,
    actions,
    mutations
};